import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { PaywallSettingsModalComponent } from "./PaywallSettingsModalComponent";

type PaywallSettingsModalComponentProps = Omit<
  ComponentPropsWithoutRef<typeof PaywallSettingsModalComponent>,
  "open" | "onOpenChange"
>;

const PaywallSettingsModal = ModalManager.create(
  (props: PaywallSettingsModalComponentProps) => {
    const modal = useModal();

    return (
      <PaywallSettingsModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            void modal.hide();
          }
        }}
      />
    );
  },
);

export const usePaywallSettingsModal = () => useModal(PaywallSettingsModal);
